import React, { createContext, useContext, ReactNode } from "react";
import { User } from "../gql/types";

type UserContextType = {
    user: User | null;
    setUser: React.Dispatch<React.SetStateAction<User | null>>;
};

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider = ({
    children,
    user,
    setUser,
}: {
    children: ReactNode;
    user: User | null;
    setUser: React.Dispatch<React.SetStateAction<User | null>>;
}) => (
    <UserContext.Provider value={{ user, setUser }}>
        {children}
    </UserContext.Provider>
);

export const useUser = (): UserContextType => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useUser must be used within a UserProvider");
    }
    return context;
};
